export function MakeModelColumn(product) {
	const { make, model, subModel } = product;

	if (!make || !model) return '';

	return [make, model, subModel].join(' ').trim();
}
